import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './App.scss';
import HeaderContainer from '../header/Header';
import FooterContainer from '../footer/Footer';
import AnnotationsSidebar from '../annotationsSidebar/AnnotationsSidebar';
import AdditionalResourcesBar from '../additionalResourcesBar/AdditionalResourcesBar';
import studentHighlightsActions from '../../actions/StudentHighlightsActions';
import annotationService from '../../services/AnnotationService';
import storeManager from '../../store/StoreManager';

import annotationItemStyles from '../annotationsSidebar/annotationItem/annotationItem.scss';
import ChatSidebar from '../chatSidebar/ChatSidebar';
import appMainScreenSelector from '../../selectors/app/AppMainScreenSelector';
import ZoomWrapper from '../remoteOralExam/zoomIntegration/ZoomWrapper';

const AppMainScreen = (props) => {
    const {
        children,
        addAppWrapper,
        showFooter,
        showChatSidebar,
        showHeader,
        isNoteTakingAndHighlightingEnabled,
        isCurrentWordFormationQuestion,
        showAdditionalResourcesBar,
        showAnnotationsSidebar,
        showZoomCall,
    } = props;

    const contentContainerStyles = [styles.contentContainer];

    if (!showHeader) {
        contentContainerStyles.push('header-disabled');
    }

    if (isCurrentWordFormationQuestion) {
        contentContainerStyles.push(styles.wordFormationQuestionContainer);
    }

    const AppContainerComponent = addAppWrapper
        ? children
        : (<div id="appContentContainer" className={contentContainerStyles.join(' ')}>
            {children}
        </div>);

    const HeaderComponent = showHeader ? <HeaderContainer showFooter={showFooter} /> : null;
    const FooterComponent = showFooter ? <FooterContainer /> : null;
    const AdditionalResourcesBarComponent = showAdditionalResourcesBar ? <AdditionalResourcesBar /> : null;
    const AnnotationsSidebarComponent = showAnnotationsSidebar ? <AnnotationsSidebar /> : null;
    const ChatSidebarComponent = showChatSidebar ? <ChatSidebar /> : null;
    const ZoomIntegrationComponent = showZoomCall ? <ZoomWrapper /> : null;

    const onAppMainScreenClick = (e) => {
        const store = storeManager.getStore();

        const isAnnotationRelatedNode = e.target.closest(`.${annotationItemStyles.annotationItem}`) || e.target.closest('.hypothesis-highlight');

        if (!isAnnotationRelatedNode) {
            store.dispatch(studentHighlightsActions.setFocusedAnnotation(null));
            annotationService.dispatchFocusAnnotationEvent(null);
        }
    };

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div className={styles.mainScreen} onClick={isNoteTakingAndHighlightingEnabled ? onAppMainScreenClick : undefined} >
            <div className={styles.mainScreenContent} id="main-screen-content">
                {HeaderComponent}
                {AppContainerComponent}
                {ZoomIntegrationComponent}
                <div className={styles.footerWrapper}>
                    {FooterComponent}
                    {AdditionalResourcesBarComponent}
                </div>
            </div>
            {AnnotationsSidebarComponent}
            {ChatSidebarComponent}
        </div>
    );
};

AppMainScreen.propTypes = {
    addAppWrapper: PropTypes.bool.isRequired,
    children: PropTypes.object,
    isNoteTakingAndHighlightingEnabled: PropTypes.bool.isRequired,
    isCurrentWordFormationQuestion: PropTypes.bool.isRequired,
    showAdditionalResourcesBar: PropTypes.bool.isRequired,
    showAnnotationsSidebar: PropTypes.bool.isRequired,
    showChatSidebar: PropTypes.bool.isRequired,
    showFooter: PropTypes.bool.isRequired,
    showHeader: PropTypes.bool.isRequired,
    showZoomCall: PropTypes.bool.isRequired,
};

const mapStateToProps = state => appMainScreenSelector.selectProps(state);
export default connect(mapStateToProps)(AppMainScreen);
